import 'reflect-metadata';
import { BaseEntity } from '../core/entities/base.entity';
import { Relation } from '../core/decorators/relation.decorator';
import { RelationRef } from '../core/types/entity-types';
import {
  LearningSectionContainerEntity
} from '../learning-section/learning-section-container/learning-section-container-entity';
import { ConsumerEntity } from '../consumer/consumer.entity';
import { SequenceEntity } from '../sequence/sequence.entity';
import { SubjectEntity } from '../subject/subject.entity';
import { ConsumerData } from '../core/types';

interface LearnItemConfig {
  exerciseSubKind?: string
}

export class ExplanationEntity extends BaseEntity {
  subjectId!: string;
  name!: string;
  topics!: string[];
  assets!: string[];
  pages!: string[];
  config!: LearnItemConfig;
  approval!: string;
  active!: boolean;
  version!: number;
  sortName!: string;
  updated!: Date;
  changedBy!: string;
  consumerData!: ConsumerData;
  consumerId!: string;
  copyRestricted!: boolean;

  @Relation()
  consumers?: RelationRef<ConsumerEntity>[];

  @Relation()
  subjects?: RelationRef<SubjectEntity>[];

  @Relation()
  sequences?: RelationRef<SequenceEntity>[];

  @Relation()
  learningSectionContainers?: RelationRef<LearningSectionContainerEntity>[];
}
